import { useState, useEffect } from 'react';
import CodeRain from './CodeRain';
import NeonParticles from './NeonParticles';

const CyberpunkAesthetics = () => {
  // Check dark mode directly from DOM to avoid context re-render loops
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    // Only check on mount - don't watch for changes to avoid re-renders
    setIsDarkMode(document.documentElement.classList.contains('dark'));
  }, []); // Empty deps - only run once

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: -1,
      }}
      aria-hidden="true"
    >
      {/* Layer 1: Floating neon particles */}
      <div style={{ opacity: isDarkMode ? 0.3 : 0.25 }}>
        <NeonParticles />
      </div>

      {/* Layer 2: Matrix code rain - passes isDarkMode directly */}
      <CodeRain isDarkMode={isDarkMode} />
    </div>
  );
};

export default CyberpunkAesthetics;
